import * as React from "react";
import { IModule } from "../../hooks/module";
import { EModule } from "../table/filter/useTables";
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useTheme } from "@mui/material";

export default function ModuleMenu({
  changeModule,
  modules,
  open,
}: {
  open: boolean;
  changeModule: ({ module }: { module: "" | EModule }) => void;
  modules: IModule[];
}) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const theme = useTheme();

  const handleClickModule = (module: EModule) => {
    changeModule({ module });
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
      <ListItem disablePadding sx={{ display: "block" }}>
        {modules.map(({ key, name, icon: Icon }) => (
          <ListItemButton
            key={key}
            onClick={() => handleClickModule(key)}
            sx={{
              minHeight: 48,
              justifyContent: open ? "initial" : "center",
              px: 2.5,
              "&:hover": {
                backgroundColor: theme.palette.action.hover,
                "& .MuiListItemIcon-root": {
                  color: theme.palette.text.primary,
                },
                "& .MuiTypography-root": {
                  color: theme.palette.text.primary,
                  fontWeight: 600,
                },
              },
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: open ? 2 : "auto",
                justifyContent: "center",
                color: theme.palette.text.secondary,
              }}
            >
              <Icon sx={{ fontSize: "1.25rem" }} />
            </ListItemIcon>
            {open && (
              <ListItemText
                primary={name}
                primaryTypographyProps={{
                  fontSize: "0.95rem",
                  fontWeight: 400,
                  color: theme.palette.text.secondary,
                }}
              />
            )}
          </ListItemButton>
        ))}
      </ListItem>
    </React.Fragment>
  );
}
